import axios from 'axios';
import '../../common/axiosInterceptor/axios-interceptor';

const BASE = `${process.env.REACT_APP_API_BASE_URL}/admindashboard/api/v1/uota`;

const request = (config) => axios.request({ authRequired: true, ...config });

export const listNx5Directories = (channel) =>
  request({
    method: 'get',
    url: `${BASE}/directories`,
    params: channel ? { channel } : undefined,
  });

export const listNx5DirectoryFiles = (directory, channel) =>
  request({
    method: 'get',
    url: `${BASE}/files`,
    params: { directory, channel },
  });

export const uploadNx5Files = (directory, formData, onUploadProgress, channel) =>
  request({
    method: 'post',
    url: `${BASE}/files`,
    params: { directory, channel },
    data: formData,
    maxBodyLength: Infinity,
    maxContentLength: Infinity,
    timeout: 300000,
    onUploadProgress,
  });

export const deleteNx5File = (id) =>
  request({
    method: 'delete',
    url: `${BASE}/files/${id}`,
  });

export const assignNx5Version = (data) =>
  request({
    method: 'post',
    url: `${BASE}/versions`,
    data,
    headers: { 'Content-Type': 'application/json' },
  });

export const listNx5Versions = () =>
  request({
    method: 'get',
    url: `${BASE}/versions`,
  });

export const listNx5Releases = (channel) =>
  request({
    method: 'get',
    url: `${BASE}/releases`,
    params: channel ? { channel } : undefined,
  });

export const createNx5Release = (data) =>
  request({
    method: 'post',
    url: `${BASE}/releases`,
    data,
    headers: { 'Content-Type': 'application/json' },
  });

export const assignNx5Device = (data) =>
  request({
    method: 'post',
    url: `${BASE}/devices`,
    data,
    headers: { 'Content-Type': 'application/json' },
  });
